// ** Reducers Imports
import layout from './layout'
import navbar from './navbar'
import whatsappSlice  from './whatsappSlice'

const rootReducer = { navbar, layout, whatsappSlice }

export default rootReducer
